import { useLocation } from "react-router-dom";
import { getFinanceModuleBase } from "../utils";

// Devuelve el prefijo de la sección desde la que se está navegando
// ("finance", "accounting" o "funds"). Sirve para que los links internos de
// una pantalla compartida no te saquen a Finanzas cuando entraste por
// Contabilidad o por Fondos de reserva.
const useModuleBase = () => getFinanceModuleBase(useLocation().pathname);

export default useModuleBase;
